import range from 'lodash/range';

export const getArrayRange = (start: number, end: number) =>
  range(start, end + 1).map((item) => ({
    label: `${item}`,
    value: item.toString(),
  }));
